import React from "react";
import styled from "styled-components";

import { UIConstants } from "../../../styles/uiConstants";
import { MandatesStatusFilter } from "./filter-button";

interface FilterBarProps {
  isRTL: boolean;
}

export const FilterBar = (props: FilterBarProps) => {
  const { isRTL } = props;

  return (
    <FilterBarContainer $isRTL={isRTL}>
      <StyledMandatesStatusFilter $isRTL={isRTL} />
    </FilterBarContainer>
  );
};

const StyledMandatesStatusFilter = styled(MandatesStatusFilter)<{ $isRTL: boolean }>`
  margin-left: ${(props) => (props.$isRTL ? 10 : 0)}px;
  margin-right: ${(props) => (props.$isRTL ? 0 : 10)}px;
  @media (max-width: ${UIConstants.TABLET_BREAKPOINT}px) {
    margin-right: 0px;
    margin-left: 0px;
    margin-bottom: 10px;
  }
`;

const FilterBarContainer = styled.div<{ $isRTL: boolean }>`
  display: flex;
  flex-direction: row;
  margin-left: ${(props) => (props.$isRTL ? 0 : 10)}px;
  margin-right: ${(props) => (props.$isRTL ? 10 : 0)}px;
  margin-top: 30px;
  margin-bottom: 10px;

  @media (max-width: ${UIConstants.TABLET_BREAKPOINT}px) {
    flex-direction: column;
    margin-left: 0px;
    margin-right: 0px;
  }
  z-index: 5;
`;
